import { api } from "@/http/api-client"
import type { TListPendingInvitesResponse } from "./types"

export function listPendingInvites() {
  return api.get<TListPendingInvitesResponse>("/invites/pending")
}
